import React, { useState, useEffect } from "react";
import { CheckPicker, SelectPicker } from "rsuite";

interface FilterOption {
	[key: string]: string;
}

interface FilterComponentProps {
	type: "multi" | "single";
	filterKey?: string;
	filterName?: string;
	options: FilterOption[];
	labelKey?: string;
	valueKey?: string;
	value?: string[];
	loading?: boolean;
	cleanable?: boolean;
	onFilterChange?: any;
	onDropdownOpen?: () => void;
	onClean?: () => void;
	onClose?: () => void;
	placeholder?: string
	defaultValue?: string[]

}

const FilterComponent: React.FC<FilterComponentProps> = ({
	type = "multi",
	filterKey,
	filterName,
	options,
	labelKey,
	valueKey,
	value,
	loading,
	cleanable = true,
	onFilterChange,
	onDropdownOpen,
	onClean,
	onClose,
	placeholder,
	defaultValue
}) => {

	return (
		<div className="flex flex-col">
			<p className="filter-header">{filterName}</p>
			{(type == "multi") ? <CheckPicker
				size="xs"
				data={options}
				placeholder={placeholder || "All"}
				labelKey={labelKey}
				valueKey={valueKey}
				value={value}
				className="main-filter max-w-[8vw] min-w-[8vw] z-10"
				onChange={onFilterChange}
				name={filterName?.toLowerCase().trim()}
				defaultValue={defaultValue}
				cleanable={cleanable}
				virtualized
			/> :
				(type === "single") ? <SelectPicker
					size="xs"
					data={options}
					placeholder={placeholder || "All"}
					labelKey={labelKey}
					valueKey={valueKey}
					className="main-filter max-w-[8vw] min-w-[8vw] z-10"
					value={value?.[0] || null}
					onChange={onFilterChange}
					name={filterName?.toLowerCase().trim()}
					virtualized
					cleanable={cleanable}
					onClean={onClean}
					onClose={onClose}
				/> : <></>}
		</div>
	);
};

export default FilterComponent;
